import { createSelector } from 'reselect'

const getFilters = (state, layerName) => {
  return state.layer.filters
}

const getLayerName = (state, layerName) => {
  return layerName
}

export const makeGetFilter = () => {
  return createSelector([getFilters, getLayerName], (filters, layerName) => {
    if (filters && layerName) {
      return filters[layerName]
    } else {
      return []
    }
  })
}



// WEBPACK FOOTER //
// ./src/selectors/filterSelector.js